<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-card class="dt-container mt-2">
                    <v-data-table
                        :mobile="isMobileOrTablet()"
                        :headers="headers"
                        :items="data"
                        :search="search"
                        :loading="loading"
                        :items-per-page="15"
                        :items-per-page-options="[15, 30, 50, 100, -1]"
                    >
                        <template v-slot:loading>
                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                        </template>

                        <template v-slot:item.outcomes_count="{ item }">
                            <v-chip :color="item.outcomes_count > 0 ? 'blue' : 'grey'" size="small" variant="elevated">
                                {{ item.outcomes_count }}
                            </v-chip>
                        </template>

                        <template v-slot:item.entered_scores_count="{ item }">
                            <v-chip
                                :color="item.is_complete ? 'green' : item.entered_scores_count > 0 ? 'orange' : 'grey'"
                                size="small"
                                variant="elevated"
                            >
                                {{ item.entered_scores_count }} / {{ item.outcomes_count }}
                            </v-chip>
                        </template>

                        <template v-slot:item.average_score="{ item }">
                            <span v-if="item.average_score !== null">{{ item.average_score }}</span>
                            <span v-else class="text-grey">N/A</span>
                        </template>

                        <template v-slot:[`item.action`]="{ item }">
                            <div class="d-flex justify-end ga-2">
                                <v-btn
                                    @click="showScoresDialog(item)"
                                    size="small"
                                    variant="outlined"
                                    color="green"
                                    elevation="3"
                                >
                                    {{ item.outcomes_count > 0 ? 'Input Scores' : 'View' }}
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:no-data>
                            <div class="d-flex justify-center pa-8">
                                <div class="text-center text-grey">
                                    <v-icon size="48" class="mb-2">mdi-clipboard-text-outline</v-icon>
                                    <div class="text-body-2">No faculty loads found for the selected semester.</div>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <CourseOutcomeScoresDialog ref="CourseOutcomeScoresDialog" @refresh="init()" />
</template>

<script>
import { defineComponent } from 'vue'
import CourseOutcomeScoresDialog from '../Dialogs/CourseOutcomeScoresDialog.vue'

export default defineComponent({
    components: {
        CourseOutcomeScoresDialog,
    },
    data() {
        return {
            search: null,
            loading: false,
            data: [],
            headers: [
                { title: 'Course Code', align: 'start', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Section', align: 'start', sortable: true, key: 'section_code' },
                { title: 'Course Outcomes', align: 'center', sortable: true, key: 'outcomes_count' },
                { title: 'Entered Scores', align: 'center', sortable: true, key: 'entered_scores_count' },
                { title: 'Average', align: 'center', sortable: true, key: 'average_score' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        async init() {
            this.loading = true

            const res = await this.axiosCall(
                '/course-outcomes-scores/faculty/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
                'get',
                null,
                true,
            )

            if (res && res.status === 200) {
                this.data = res.data
            }

            this.loading = false
        },
        showScoresDialog(item) {
            this.$refs.CourseOutcomeScoresDialog.init(item)
        },
    },
    mounted() {
        this.init()
    },
})
</script>

<style scoped>
</style>